{
  "static-content-online-booking-benefit": {
    "buttons": {},
    "text": {
      "title-1": "Réservez en ligne et ",
      "title-2": "débloquer des avantages exclusifs !",
      "description": "Faites l'expérience de la commodité ultime grâce à notre outil de réservation en ligne. Que ce soit le jour ou la nuit, vous pouvez prendre rendez-vous 24 heures sur 24, 7 jours sur 7, de n'importe où, en utilisant simplement votre appareil intelligent et une connexion Internet. De plus, vous avez accès à des offres spéciales telles que des réductions et des promotions exclusives à l'heure de l'apéritif. Prenez le contrôle de vos rendez-vous et profitez des avantages d'une réservation en ligne transparente !",
      "any-time-title": "Livre 24/7",
      "any-time-description": "Réservez votre rendez-vous en ligne, quelle que soit l'heure",
      "any-where-title": "Réserver depuis n'importe où",
      "any-where-description": "Depuis votre lit, ou en chemin",
      "discount-title": "Meilleures offres",
      "discount-description": "Ne manquez pas nos meilleures offres ! Bénéficiez de remises exceptionnelles et d'offres exclusives à l'heure de l'apéritif dès maintenant"
    }
  }
}
